
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sourcing/suppliers/[handle]",
      function () {
        return require("private-next-pages/sourcing/suppliers/[handle]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sourcing/suppliers/[handle]"])
      });
    }
  